import { Component } from 'react'
import { osName } from 'react-device-detect'
import { getErrorMessage } from '../../common/ErrorForTranslation'

export default class AbstractSetupPart extends Component {
	static decideGlyphiconClassname(status) {
		switch (status) {
			case 'upcoming':
				return 'glyphicon-question-sign'
			case 'in-progress':
				return 'fa fa-spinner fa-spin'
			case 'succeeded':
				return 'glyphicon-ok-sign'
			default:
				return 'glyphicon-remove-sign'
		}
	}

	static decidePanelClassname(status) {
		switch (status) {
			case 'upcoming':
				return 'panel-info'
			case 'in-progress':
				return 'panel-warning'
			case 'succeeded':
				return 'panel-success'
			default:
				return 'panel-danger'
		}
	}

	static getOs() {
		return osName
			.trim()
			.toUpperCase()
			.replace(' ', '_')
	}

	getErrorMessage(err) {
		return getErrorMessage(err, this.props.translate)
	}

	processCheck() {
		throw new Error(
			'Method processCheck must be overridden in children implementation. '
		)
	}

	resetCheck() {
		throw new Error(
			'Method resetCheck must be overridden in children implementation. '
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/qzSetup/AbstractSetupPart.js